import { createSlice } from '@reduxjs/toolkit';
// import type { PayloadAction } from '@reduxjs/toolkit';

export interface CursoState {
    cid: string
    grupo: number
    sigla: string
    nombre: string
    descripcion: string
    modulos: Array<ModuloState>
    noticias: Array<NoticiaState>
}

export interface ModuloState {
    numero: number
    nombre: string
    bloques: Array<BloqueState>
}

export interface BloqueState {
    numero: number
    nombre: string
    secciones: Array<SeccionState>
}

export interface SeccionState {
    numero: number
    nombre: string
    activo: boolean
}

export interface NoticiaState {
    nid: string
}





export interface AyudantiaState {
    id: string
    curso: string
    modulo: string
    numero: number
    enunciado: string
    solucion: string
}

export interface AlternativaState {
    letra: string
    alternativa: string
    estado: boolean
}

export interface EjercicioState {
    enunciado: string
    alternativas: Array<AlternativaState>
    estado: undefined | boolean
}

export interface DiapositivaState {
    page: number
    content: string
}

// export interface SeccionState {
//     sid: string
//     curso: string
//     section: number
//     modulo: string
//     bloque: string
//     seccion: string
//     nombre: string
//     ejercicios: Array<EjercicioState>
//     clase: string
//     activo: boolean
//     diapositivas: Array<DiapositivaState>
//     estadistica: {
//         correctas: number,
//         incorrectas: number, 
//         max: number
//     },
//     autor: string
// }

export interface CursosState {
    cursos: Array<CursoState>
    modulos: Array<ModuloState>
    bloques: Array<BloqueState>
    secciones: Array<SeccionState>
    seccion: SeccionState
    ayudantias: Array<AyudantiaState>
    ejercicios: Array<any>
    noticias: Array<NoticiaState>
    curso: CursoState
    modulo: string
    isLoading: boolean
}

const initialState: CursosState = {
    cursos: [], 
    modulos: [],
    bloques: [],
    secciones: [],
    seccion: {
        numero: 0,
        nombre: '',
        // ejercicios: [],
        activo: false,
        // estadistica: {
        //     correctas: 0,
        //     incorrectas: 0,
        //     max: 0
        // },
        // diapositivas:[],
        // autor: ''
    },
    ayudantias: [],
    ejercicios: [],
    curso: {
        cid: '',
        grupo: 0,
        sigla: '',
        nombre: '',
        descripcion: '', 
        modulos: [
            {
                numero: 1, 
                nombre: '',
                bloques: [
                    {
                        numero: 1, 
                        nombre: '',
                        secciones: [
                            {
                                numero: 1, 
                                nombre: '',
                                activo: false
                            }
                        ]
                    }
                ]
            }
        ], 
        noticias: [
            {nid: ''}
        ]
    },
    modulo: '', 
    noticias: [],
    isLoading: false

}

export const cursoSlice = createSlice({
    name: 'cursos',
    initialState,
    reducers: {
        setCursos: (state, action) => {
            state.cursos = action.payload
        },
        setCurso: (state, action) => {
            state.curso = action.payload
        },
        setModulo: (state, action) => {
            state.modulo = action.payload
        },
        setModulos: (state, action) => {
            state.modulos = action.payload
        },
        setBloques: (state, action) => {
            state.bloques = action.payload
        },
        setSecciones: (state, action) => {
            state.secciones = action.payload
        },
        setSeccion: (state, action) => {
            state.seccion = action.payload
        },  
        setAyudantias: (state, action) => {
            state.ayudantias = action.payload
        },
        setEjercicios: (state, action) => {
            state.ejercicios = action.payload
        },
        setNoticias: (state, action) => {
            state.noticias = action.payload
        },
        startLoadingCurso: (state) => {
            state.isLoading = true;
        },
        endLoadingCurso: (state) => {
            state.isLoading = false;
        },
    },
})

// Action creators are generated for each case reducer function
export const { 
    setCursos, 
    setModulos, 
    setBloques, 
    setSecciones, 
    setAyudantias,
    setEjercicios,
    setCurso, 
    setModulo, 
    setNoticias,
    startLoadingCurso, 
    endLoadingCurso 
} = cursoSlice.actions

